import React, { Component } from 'react'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import './gallery-modal.scss'
import ReactGA from 'react-ga'

class GalleryModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
          photoIndex: this.props.photoIndex
        };

        ReactGA.event({
            category: 'Image',
            action: `${this.props.photoIndex} clicked`
        });
    }

    onCloseRequest = () => {
        this.props.closeModal();
    }

    render() {
        const images = this.props.images;
        const { photoIndex } = this.state;

        return(
            <div>
                <Lightbox
                  mainSrc={images[photoIndex]}
                  nextSrc={images[(photoIndex + 1) % images.length]}
                  prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                  onCloseRequest={this.onCloseRequest}
                  onMovePrevRequest={() =>
                      this.setState({
                        photoIndex: (photoIndex + images.length - 1) % images.length,
                      })
                    }
                    onMoveNextRequest={() =>
                      this.setState({
                        photoIndex: (photoIndex + 1) % images.length,
                      })
                    }
                  enableZoom={false}
                />
            </div>
        );
    }
}

export default GalleryModal;



// WEBPACK FOOTER //
// ./src/components/GalleryModal/GalleryModal.js